module.exports = __webpack_public_path__ + "static/media/flash.4b1d7359.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/flash.svg
// module id = 1160
// module chunks = 0